// extracted by mini-css-extract-plugin
module.exports = {"main":"RobotChatButton_main_3Sjrr","avatar":"RobotChatButton_avatar_2YuTb"};